import React from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import { startCase } from "lodash";
import noImageFound from "../../assets/images/No-image-found.jpg";

const UserView = ({ setViewShowModal, item }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto my-6 mx-auto max-w-3xl">
          <form className="sm:py-4 sm:px-2 py-8 px-7">
            <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[940px] max-h-[96vh] overflow-y-auto	">
              <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                <h3 className="text-xl font-semibold">{t("O_VIEW_USER")}</h3>
                <button
                  className=" ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none"
                  onClick={() => setViewShowModal(false)}
                >
                  <span className=" text-[#B8BBBF]  text-4xl " title="Close">
                    ×
                  </span>
                </button>
              </div>
              <div className="relative p-6 flex-auto">
                <h3 className="text-xl font-semibold">Personal details</h3>
                <div className="grid grid-cols-3">
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Company ID</strong>
                      <h6>{item._id || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Company name</strong>
                      <h6>{item.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Company number</strong>
                      <h6>{item.companyNumber || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Email ID</strong>
                      <h6>{item.officialEmail || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Registered date</strong>
                      <h6>
                        {dayjs(item?.createdAt).format(
                          "MM-DD-YYYY hh:mm A",
                        )}{" "}
                      </h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Country</strong>
                      <h6>{item.Country?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>State</strong>
                      <h6>{item.State?.name || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>City</strong>
                      <h6>{item.city || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Zipcode</strong>
                      <h6>{item.zipcode || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Status</strong>
                      <h6>{startCase(item.status || "")}</h6>
                    </div>
                  </div>
                  <div className="sm:py-4 sm:px-2 py-8 px-7">
                    <div className="relative z-0 mb-2 w-full group">
                      <strong>Address</strong>
                      <h6>{item.address || ""}</h6>
                    </div>
                  </div>
                  <div className="sm:pt-4 sm:px-2 pt-8 pb-0 px-7">
                    <div className="relative z-0 mb-0 w-full group">
                      <strong>Company logo</strong>
                      <img
                        src={item?.logo || noImageFound}
                        alt=""
                        className="w-16 h-16 rounded-full"
                      />
                    </div>
                  </div>
                  <div className="sm:pt-4 sm:px-2 pt-8 pb-0 px-7">
                    <div className="relative z-0 mb-0 w-full group">
                      <strong>Company profile picture</strong>
                      <img
                        src={item?.profilePicture || noImageFound}
                        alt=""
                        className="w-16 h-16 rounded-full"
                      />
                    </div>
                  </div>
                </div>
              </div>
              {item?.Subscription ? (
                <>
                  <div className="px-6">
                    {" "}
                    <hr />
                  </div>

                  <div className="relative p-6 flex-auto">
                    <h3 className="text-xl font-semibold">
                      Subscription details
                    </h3>
                    <div className="grid grid-cols-3">
                      <div className="sm:py-4 sm:px-2 py-8 px-7 ">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Subscription ID</strong>
                          <h6>{item?.Subscription?.subscriptionId || ""}</h6>
                        </div>
                      </div>
                      <div className="sm:py-4 sm:px-2 py-8 px-7">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Subscription name</strong>
                          <h6>{item?.Subscription?.subscriptionName || ""}</h6>
                        </div>
                      </div>
                      <div className="sm:py-4 sm:px-2 py-8 px-7">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Subscription amount</strong>
                          <h6>
                            {item?.Subscription?.additionalAmountPaid
                              ? item?.Subscription?.additionalAmountPaid +
                                item?.Subscription?.subscriptionAmount
                              : item?.Subscription?.subscriptionAmount || ""}
                          </h6>
                        </div>
                      </div>
                      <div className="sm:py-4 sm:px-2 py-8 px-7">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Number of employees</strong>
                          <h6>
                            {item?.Subscription?.totalEmployees ||
                              item?.Subscription?.noOfEmployee ||
                              ""}
                          </h6>
                        </div>
                      </div>
                      <div className="sm:py-4 sm:px-2 py-8 px-7">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Number of HR</strong>
                          <h6>{item?.Subscription?.noOfHR}</h6>
                        </div>
                      </div>
                      <div className="sm:py-4 sm:px-2 py-8 px-7">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Number of accountant</strong>
                          <h6>{item?.Subscription?.noOfAccountant || ""}</h6>
                        </div>
                      </div>
                      <div className="sm:py-4 sm:px-2 py-8 px-7">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Purchased date</strong>
                          <h6>
                            {dayjs(
                              item?.Subscription?.subscriptionPurchaseDate,
                            ).format("MM-DD-YYYY hh:mm A")}{" "}
                          </h6>
                        </div>
                      </div>
                      <div className="sm:py-4 sm:px-2 py-8 px-7">
                        <div className="relative z-0 mb-2 w-full group">
                          <strong>Expiry date</strong>
                          <h6>
                            {dayjs(
                              item?.Subscription?.subscriptionExpiryDate,
                            ).format("MM-DD-YYYY hh:mm A")}{" "}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
              <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                <button
                  className="text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150"
                  type="button"
                  onClick={() => setViewShowModal(false)}
                >
                  {t("O_BACK")}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black" />
    </>
  );
};

export default UserView;
